import { Typography } from '@mui/material';
import { Linking } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

function OurApp(){
	
	
	return (
    <div className='container' style={{ padding: "64px 1vw 64px 3vw" }}>
      <Typography variant="h4" component="h4" mb={4}>
      How to Sync/Install Watch Faces
      </Typography>
	  
				<h2> Install Amazfit watch face directly using <a href="/ourapp" style={{color : '#FF0000'}}>our apps</a> </h2>
				<br></br>
				<h3>Manually installing custom watchface on Mi Band 4, Mi Band 5 via MiFit application</h3>
				
			
				<br></br>
				  <li>Download the watchface/dial .bin & image gif file that you want to install.</li>
				  <li>For Mi Band 4 - Using file manager go to folder /Android/data/com.xiaomi.hm.health/files/watch_skin_local/ </li>
				  <li>For Mi Band 5 - Using file manager go to folder /Android/data/com.xiaomi.hm.health/files/watch_skin_file/59/ </li>
				  <li>Make new folder (one folder for one watch face).</li>
				  <li>Copy downloaded .BIN and gif image in your new folder and also .xml file</li>
				  <li>Open Mi fit and  Go to Profile -> Mi Smart Band 4/5 -> Band Display/WatchFace Settings -> My Band Display/Local WatchFace.</li>
				  <li>Select WatchFace/Display you downloaded.</li>
				  <li>Click Sync Watchface.</li>
				  
			
				
				<br></br>
				
				<h3>Manually installing custom watchface Amazfit Band 5 and Amazfit X smart band via Amazfit/Zepp application</h3>
				<br></br>
				
					<li>Install any one of the stock watch faces available in Amazfit/Zepp (if you have already installed one, you may skip this step).</li>
				    <li>Open the folder using the file manager with the path: /Android/data/com.huami.watch.hmwatchmanager/files/watch_skin_local/</li>
					<li>Here you will find folders with downloaded stock watch faces.</li>
					<li>Go to any of these folders and find the .bin file. Copy the .bin file name only.</li>
					<li>Go to the custom watch face .bin file and rename it using the name of the stock watch face you just copied.</li>
					<li>Replace stock .bin file with custom .bin watch face file using file manager.</li>
					<li>Open the Amazfit/Zepp app and install the stock watch face, which file you replaced.</li>
					<li>Note! The preview image will not change.</li>
				
				
				
				<br></br>
				<h3>Manually installing custom watchfaces on Amazfit Verge, Pace, Stratos via PC or Mac</h3>
				
				<br></br>
				
					<h4>Installing .WFZ watch faces via PC</h4>
					  <li>Connect your watch to the computer.</li>
					  <li>Install drivers if needed (more often it is not necessary).</li>
					  <li>After successful connection, the internal memory of the device will be available to you. Go to the WatchFace folder.</li>
					  <li>Copy there all the watch faces that you would like to set on the watch.</li>
					  <li>Disconnect the device from PC.</li>
					  <li>Now the watch faces will be available for installation in the watch's menu of the Amazfit application.</li>
					  <li>Note: The downloaded file should have .wfz extension (watchface.wfz).</li>
				
					<h4>Setting .WFZ watch faces via Mac</h4>
					  <li>Connect the smartwatch to Mac.</li>
					  <li>Make sure you have Android File Transfer installed.</li>
					  <li>After connection, the internal memory of the device will be available to you. Go to the WatchFace folder.</li>
					  <li>Copy there all the watch faces that you would like to set on the watch.</li>
					  <li>Disconnect the device from Mac.</li>
					  <li>Now the watch faces will be available for installation in the watch's menu of the Amazfit application.</li>
					  <li>Note: The downloaded file should have .wfz extension (watchface.wfz).</li>
				
				
				<br></br>
				<h3>Manually installing custom watchfaces on Amazfit GTR, GTS, T-Rex, Verge Lite, Bip via Amazfit/Zepp application</h3>
				<br></br>
			
				
					<h4>Installation for Android</h4>
				    <li>Install any one of the stock watch faces available in Amazfit/Zepp (if you have already installed one, skip this step).</li>
				    <li>Open the folder using the file manager with the path: /Android/data/com.huami.watch.hmwatchmanager/files/watch_skin_local/</li>
					<li>Here you will find folders with downloaded stock watch faces.</li>
					<li>Go to any of these folders and find the .bin file. Copy the .bin file name only.</li>
					<li>Go to the custom watch face .bin file and rename it using the name of the stock watch face you just copied.</li>
					<li>Replace stock .bin file with custom .bin watch face file using file manager.</li>
					<li>Open the Amazfit/Zepp app and install the stock watch face, which file you replaced.</li>
					<li>Note! The preview image will not change.</li>
				
				
					<h4>Installation for iOS</h4>
				    <li>Install any one of the stock watch faces available in Amazfit/Zepp (if you have already installed one, skip this step).</li>
				    <li>Open the folder using the file manager with the path: /iPhone/Amazfit/watchSkin/</li>
					<li>Here you will find folders with downloaded stock watch faces.</li>
					<li>Go to any of these folders and find the .bin file. Copy the .bin file name only.</li>
					<li>Go to the custom watch face .bin file and rename it using the name of the stock watch face you just copied.</li>
					<li>Replace stock .bin file with custom .bin watch face file using file manager.</li>
					<li>Open the Amazfit/Zepp app and install the stock watch face, which file you replaced.</li>
					<li>Note! The preview image will not change.</li>
				
					   
      
    </div>
	);
}
export default OurApp